import { render, staticRenderFns } from "./QuizIcon.vue?vue&type=template&id=0fb0cb04"
import script from "./QuizIcon.vue?vue&type=script&lang=js"
export * from "./QuizIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports